import React from 'react';
import Icon from '../../../components/Icon';

export default {
    logos: [
        {
            link: CONFIG.myPage.frontPageUri,
            image: <Icon name="logos/schibsted" />,
        },
    ],
    availableRedirectUrls: [
        'https://schibsted.no',
    ],
};
